import { avatarUrl } from "@/lib/archetypes";

type Props = {
  seed: string | null | undefined;
  style?: string | null | undefined;
  size?: number;
  className?: string;
  alt?: string;
};

export function Avatar({ seed, style, size = 64, className = "", alt = "" }: Props) {
  return (
    <img
      src={avatarUrl(seed, style)}
      alt={alt}
      width={size}
      height={size}
      loading="lazy"
      className={`inline-block rounded-2xl bg-muted ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
